import { Injectable } from '@angular/core';
import { OnCallFilterDto } from '../interfaces';
import {
  EntityFilter,
  EntityFilterDto,
} from '@shared/interfaces/vt-filter-menu-item';

@Injectable({ providedIn: 'root' })
export class OnCallFiltersService {
  readonly filterFields: string[] = [
    'DataFilterID',
    'Editable',
    'Name',
    'FilterModel',
    'VisibleToAllUsers',
    'Department',
    'User',
    'Location',
    'UserTag',
    'VehicleTag',
    'OnCallStatus',
    'TranslationKey',
  ];

  saveFilterDataGetterFn = (
    responseData: { Name: string; VisibleToAllUsers?: boolean },
    filterCopyData: EntityFilter<OnCallFilterDto>
  ): Partial<EntityFilterDto<OnCallFilterDto>> =>
    ({
      Name: responseData.Name,
      FilterModel: filterCopyData.FilterModel,
      VisibleToAllUsers: responseData.VisibleToAllUsers,
      Department: filterCopyData.Department,
      User: filterCopyData.User,
      Location: filterCopyData.Location,
      UserTag: filterCopyData.UserTag,
      VehicleTag: filterCopyData.VehicleTag,
      Editable: true,
    }) as Partial<EntityFilterDto<OnCallFilterDto>>;
}
